const paths = {
  routeList: '/route/list',
  routeEdit: '/route/edit',
  routeMonitor: '/route/monitor',
  routeReport: '/route/report',
  routeStateReport: '/route/stateReport',
  routeAssignUnit: '/route/assignUnit',
  importRouteAssignments: '/route/importRouteAssignments',
  routeETAMonitor: '/route/etaMonitor',
  routeResolveWarnings: '/route/resolveWarnings',
  routeSecurity: '/route/security'
};

export default paths;
